export default __webpack_public_path__ + "static/balance_header-fce664db0b9e2f732acf5db1b6038315.png";